
export const LS_SCRIPT_URL_KEY = 'consultflow_script_url';
export const LS_AUTH_KEY = 'consultflow_admin_password';

export const DEFAULT_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbzWJw8RxnNAj5K1RNWw7bkQ3xsl3Q5mhSmEkAAQTl81NXXM3iaRuKVCrkuU4ruuSoIV/exec';
export const DEFAULT_TIME_SLOTS = '18:30,19:00,19:30,20:00,20:30,21:00,21:30';
export const DEFAULT_SITE_TITLE = 'ConsultFlow Pro';
export const DEFAULT_FORM_TITLE = '預約諮詢服務';
export const DEFAULT_TOPIC_OPTIONS = '';

// 您提供的新增快取 CSV 連結
export const CONFIG_CSV_URL = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTwk0ffp7JZ3Ik0JHNpKIsoFsBTG9Ckxy8NXzL6cw-1ZVYXNqPye_fLpPduWdcyS2GJT0wsySov6bj2/pub?gid=1148318272&single=true&output=csv';
export const BOOKINGS_CSV_URL = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTwk0ffp7JZ3Ik0JHNpKIsoFsBTG9Ckxy8NXzL6cw-1ZVYXNqPye_fLpPduWdcyS2GJT0wsySov6bj2/pub?gid=948790243&single=true&output=csv';

export const WEEK_DAYS = ['日', '一', '二', '三', '四', '五', '六'];
